import SignUp from '../pages/live/signUp';

import ProductDetail from '../pages/detail';
import Pay from '../pages/detail/pay';
import PayResult from '../pages/detail/payResult';
import OrderDetail from '../pages/order/orderDetail';
import Protocol from '../pages/protocol';

import Menu1 from '../pages/share/menu1';
import Menu2 from '../pages/share/menu2';
import Menu3 from '../pages/share/menu3';
import Menu4 from '../pages/share/menu4';

import ProductDetailCode from '../pages/share/share-code';
import Myorderlogistics from '../pages/myorder';
import Logistics from '../pages/logistics/index';

import Confirmorder from '../pages/orderConfirm/order-confirm';

import Preview from '../pages/preview/preview';
import Filepreview from '../pages/file-preview';
import Selectrole from '../pages/selectrole';
import PersonageEnroll from '../pages/personageEnroll';

import EnterpriseEnroll from '../pages/enterpriseEnroll';
import DownloadApp from '../pages/downloadApp';
import Agreement from '../pages/agreement';
import LangWangAgreement from '../pages/agreement/langwang';

import Privacy from '../pages/agreement/privacy';
import LangWangPrivacy from '../pages/agreement/langwang_privacy';

import Activity from '../pages/activity';
import RewardRule from '../pages/activity/rewardRule/reward';
import MyReward from '../pages/activity/myReward/myReward';
import ForwardReward from '../pages/activity/myReward/forwardeward';

import Live from '../pages/live';

import ChannelLevel from '../pages/channel/newChannelLevel';
import ChannelList from '../pages/channel/newChannelList';
import StudyFiles from '../pages/channel/studyFiles/study';
import Pdf from '../pages/channel/studyFiles/pdfView';
import Video from '../pages/channel/studyFiles/videoView';

import OpenAccountResult from '../pages/openAccount/result';
import OpenAccount from '../pages/openAccount';
import TcPlayer from '../pages/live/tencentVideoPLay';
import NewLive from '../pages/newLive';
import LiveRegistration from '../pages/newLive/live-registration';

import LiveShare from '../pages/liveShare/index';// 邀请函页
import Invitation from '../pages/liveShare/invitation';// 邀请同意页

import shareLive from '../pages/shareLive';// 分享
import Sharelist from '../pages/shareLive/sharelist';// 排行
import PersonalCenter from '../pages/personalCenter';// 个人
import Shop from '../pages/shop';// 店铺
import LiveList from '../pages/shop/liveList';// 店铺中直播列表更多查看

import CustomerDetail from '../pages/customerDetail';
import Model from '../pages/customerDetail/model';

const dashboardRoutes = [
  {
    key: '/productDetail',
    path: '/productDetail',
    component: ProductDetail,
  },
  {
    key: '/pay',
    path: '/pay',
    component: Pay,
  },
  {
    key: '/payResult',
    path: '/payResult',
    component: PayResult,
  },
  {
    key: '/orderDetail',
    path: '/orderDetail',
    component: OrderDetail,
  },
  {
    key: '/protocol',
    path: '/protocol',
    component: Protocol,
  },
  {
    key: '/productDetailCode/menu1',
    path: '/productDetailCode/menu1',
    component: Menu1,
  },
  {
    key: '/productDetailCode/menu2',
    path: '/productDetailCode/menu2',
    component: Menu2,
  },
  {
    key: '/productDetailCode/menu3',
    path: '/productDetailCode/menu3',
    component: Menu3,
  },
  {
    key: '/productDetailCode/menu4',
    path: '/productDetailCode/menu4',
    component: Menu4,
  },

  {
    key: '/productDetailCode',
    path: '/productDetailCode',
    component: ProductDetailCode,
  },
  {
    key: '/myorderlogistics',
    path: '/myorderlogistics',
    component: Myorderlogistics,
  },
  {
    key: '/logistics',
    path: '/logistics',
    component: Logistics,
  },
  {
    key: '/confirmorder',
    path: '/confirmorder',
    component: Confirmorder,
  },
  {
    key: '/preview',
    path: '/preview',
    component: Preview,
  },
  {
    key: '/filepreview',
    path: '/filepreview',
    component: Filepreview,
  },
  {
    key: '/selectrole',
    path: '/selectrole',
    component: Selectrole,
  },
  {
    key: '/personageEnroll',
    path: '/personageEnroll',
    component: PersonageEnroll,
  },
  {
    key: '/enterpriseEnroll',
    path: '/enterpriseEnroll',
    component: EnterpriseEnroll,
  },
  {
    key: '/downloadApp',
    path: '/downloadApp',
    component: DownloadApp,
  },
  {
    key: '/agreement',
    path: '/agreement',
    component: Agreement,
  },
  {
    key: '/langwangAgreement',
    path: '/langwangAgreement',
    component: LangWangAgreement,
  },
  {
    key: '/privacy',
    path: '/privacy',
    component: Privacy,
  },
  {
    key: '/langwangPrivacy',
    path: '/langwangPrivacy',
    component: LangWangPrivacy,
  },
  {
    key: '/Activity',
    path: '/activity',
    component: Activity,
  },
  {
    key: '/RewardRule',
    path: '/rewardRule',
    component: RewardRule,
  },
  {
    key: '/MyReward',
    path: '/myReward',
    component: MyReward,
  },
  {
    key: '/ForwardReward',
    path: '/forwardReward',
    component: ForwardReward,
  },
  {
    key: '/Live',
    path: '/live',
    component: Live,
  },
  {
    key: '/openAccount',
    path: '/openAccount',
    component: OpenAccount,
  },
  {
    key: '/ChannelLevel',
    path: '/channelLevel',
    component: ChannelLevel,
  },
  {
    key: '/ChannelList',
    path: '/channelList',
    component: ChannelList,
  },
  {
    key: '/openAccount',
    path: '/openAccount',
    component: OpenAccount,
  },
  {
    key: '/openAccountResult',
    path: '/openAccountResult',
    component: OpenAccountResult,
  },
  {
    key: '/studyFiles',
    path: '/studyFiles',
    component: StudyFiles,
  },
  {
    key: '/pdf',
    path: '/pdf',
    component: Pdf,
  },
  {
    key: '/video',
    path: '/video',
    component: Video,
  },
  {
    key: '/tcPlayer',
    path: '/tcPlayer',
    component: TcPlayer,
  },
  {
    key: '/signUp',
    path: '/signUp',
    component: SignUp,
  },
  {
    key: '/newLive',
    path: '/newLive',
    component: NewLive,
  },
  {
    key: '/liveRegistration',
    path: '/liveRegistration',
    component: LiveRegistration,
  },
  {
    key: '/sharelive',
    path: '/sharelive',
    component: shareLive,
  },
  {
    key: '/sharelist',
    path: '/sharelist',
    component: Sharelist,
  },
  {
    key: '/personalCenter',
    path: '/personalCenter',
    component: PersonalCenter,
  },
  {
    key: '/shop',
    path: '/shop',
    component: Shop,
  },
  {
    key: '/liveList',
    path: '/liveList',
    component: LiveList,
  },
  {
    key: '/liveShare',
    path: '/liveShare',
    component: LiveShare,
  },
  {
    key: '/invitation',
    path: '/invitation',
    component: Invitation,
  },
  {
    key: '/customerDetail',
    path: '/customerDetail',
    component: CustomerDetail,
  },
  {
    key: '/model',
    path: '/model',
    component: Model,
  },
];

export default dashboardRoutes;
